var map = {
	"./DeNA.png": 8370,
	"./オリックス.png": 5617,
	"./ソフトバンク.png": 3396,
	"./ヤクルト.png": 5234,
	"./ロッテ.png": 3440,
	"./中日.png": 698,
	"./巨人.png": 4442,
	"./広島.png": 9131,
	"./日本ハム.png": 4614,
	"./東北楽天.png": 3690,
	"./西武.png": 1079,
	"./阪神.png": 9108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;